import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useContactTypeReducer = () => useSelector((state: ApplicationState) => state.contactType);
